import ChangeUserPassword from './ChangeUserPassword';
import { ShadowContainer } from '../common/ShadowContainer';
import { Settings } from '@mui/icons-material';
import { Box } from '@mui/material';
import AdminForgotPassword from './AdminForgotPassword';
import AddAdmin from './AddAdmin';

const SettingsComponent = () => {
  return (
    <ShadowContainer maxWidth={800} alignSelf={'center'}>
      <Box mt={2}>
        <Settings color={'primary'}/>
      </Box>
      <Box mt={2}>
        <ChangeUserPassword/>
      </Box>
      <Box mt={2}>
        <AdminForgotPassword/>
      </Box>
      <Box mt={2}>
        <AddAdmin/>
      </Box>
    </ShadowContainer>
  );
};

export default SettingsComponent;